import imRequest from '../imRequest';
import { IM_API } from '../../constants/endpoints';

export const favoriteApi = {
  listMine: (params = {}) =>
    imRequest.get(`${IM_API}/favorites`, { params }),

  listIds: (conversationId) =>
    imRequest.get(`${IM_API}/conversations/${conversationId}/favorites`),

  add: (conversationId, serverMessageId) =>
    imRequest.put(`${IM_API}/conversations/${conversationId}/favorites/${serverMessageId}`),

  remove: (conversationId, serverMessageId) =>
    imRequest.delete(`${IM_API}/conversations/${conversationId}/favorites/${serverMessageId}`),
};
